import { trackPendoEvent } from "./pendoUtils";
import { EE_ENROLLMENT_ORIGIN_KEY } from "./useStandardizedTracking";

export const pendoEEUtils = (dispatch, application, eventName, eventTaken) => {
  const eventData = {
    eeTemplateName: application?.ApplicationFormConfigurationTemplateName,
    programName: application?.displayName,
    providerName: application?.potentialSaving?.APProvider,
    programType: application?.potentialSaving?.programType,
    programSubtypes: application?.potentialSaving?.programSubtypes,
    tmPatientId: application?.potentialSaving?.patient,
    assosiatedDrug: application?.drugDisplayName,
    actionTaken: eventTaken
  };

  const origin = sessionStorage.getItem(EE_ENROLLMENT_ORIGIN_KEY);
  if (origin) {
    eventData.origin = origin;
  }

  trackPendoEvent(dispatch, eventName, eventData);
};

export default { pendoEEUtils };
